import React from 'react'
// themes
import { colors } from 'themes/index'
import { SearchIconWrapper } from 'themes/views/layouts'
// components
import { ReduxInput } from 'components/FormElements'
import { SearchRoundedIcon } from 'components/UI/PageSearch/views'
// types
import { FilterField } from '../../index'
import { PlanFilterField } from 'hooks/plans/usePlanFilterFields'
// views
import { ArrowIcon, FieldsWrapper, FieldWrapper, IconWrapper, SearchWrapper, SectionHeader } from './views'

interface Props {
  fields: PlanFilterField[]
  filter: FilterField[]
  setField: (field: PlanFilterField) => void
  setIsConfigured: (value: boolean) => void
}

const Fields: React.FC<Props> = ({ fields, filter, setField, setIsConfigured }) => {
  const grouped = React.useMemo(() => {
    const map = new Map<string, PlanFilterField[]>()

    for (const field of fields) {
      const group = map.get(field.entityName) ?? []

      group.push(field)
      map.set(field.entityName, group)
    }
    return map
  }, [fields])

  return (
    <>
      {!!filter.length && (
        <IconWrapper>
          <ArrowIcon htmlColor={colors.purple400} onClick={() => setIsConfigured(false)} />
        </IconWrapper>
      )}
      <form>
        <SearchWrapper>
          <SearchIconWrapper>
            <SearchRoundedIcon htmlColor={colors.gray380} />
          </SearchIconWrapper>
          <ReduxInput withEllipsis name='search' disableUnderline placeholder='Search...' />
        </SearchWrapper>
      </form>
      <FieldsWrapper>
        {Array.from(grouped.entries()).map(([entityName, entityFields]) => (
          <React.Fragment key={entityName}>
            <SectionHeader>{entityName}</SectionHeader>
            {entityFields.map((field) => (
              <FieldWrapper key={field.id} onClick={() => setField(field)}>
                {field.label}
              </FieldWrapper>
            ))}
          </React.Fragment>
        ))}
      </FieldsWrapper>
    </>
  )
}

export default Fields
